var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 42.0225,
    stroke: "#FAA53D",
    strokeWidth: 0.816917
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59.5915,
    stroke: "#FAA53D",
    strokeWidth: 0.816917
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.686,
    cy: 16.9251,
    r: 0.947804,
    fill: "#B8ACF6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3226,
    cy: 45.5347,
    r: 0.947804,
    fill: "#FFD39E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.8538,
    cy: 76.2068,
    r: 0.947804,
    fill: "#FFD39E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 103.852,
    r: 0.677003,
    fill: "url(#paint0_linear_927_765)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 46H38C35.7909 46 34 47.7909 34 50V82C34 84.2091 35.7909 86 38 86H82C84.2091 86 86 84.2091 86 82V50C86 47.7909 84.2091 46 82 46Z",
    fill: "url(#paint1_linear_927_765)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 56H34V60H86V56Z",
    fill: "#E6EAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 58C66.6274 58 72 52.6274 72 46C72 39.3726 66.6274 34 60 34C53.3726 34 48 39.3726 48 46C48 52.6274 53.3726 58 60 58Z",
    fill: "#11BC59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7601 51.3799C58.4969 51.3814 58.236 51.331 57.9923 51.2314C57.7486 51.1319 57.527 50.9853 57.3401 50.7999L53.8001 47.2599C53.4235 46.8833 53.2119 46.3725 53.2119 45.8399C53.2119 45.3073 53.4235 44.7965 53.8001 44.4199C54.1767 44.0433 54.6875 43.8317 55.2201 43.8317C55.7527 43.8317 56.2635 44.0433 56.6401 44.4199L58.7601 46.5399L62.9601 42.3399C63.146 42.1524 63.3672 42.0036 63.6109 41.9021C63.8547 41.8006 64.1161 41.7483 64.3801 41.7483C64.6441 41.7483 64.9055 41.8006 65.1493 41.9021C65.393 42.0036 65.6142 42.1524 65.8001 42.3399C66.1726 42.7146 66.3817 43.2215 66.3817 43.7499C66.3817 44.2783 66.1726 44.7852 65.8001 45.1599L60.1601 50.7999C59.7876 51.1694 59.2848 51.3777 58.7601 51.3799Z",
    fill: "#E6EAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 76H42C41.4696 76 40.9609 75.7893 40.5858 75.4142C40.2107 75.0391 40 74.5304 40 74C40 73.4696 40.2107 72.9609 40.5858 72.5858C40.9609 72.2107 41.4696 72 42 72H54C54.5304 72 55.0391 72.2107 55.4142 72.5858C55.7893 72.9609 56 73.4696 56 74C56 74.5304 55.7893 75.0391 55.4142 75.4142C55.0391 75.7893 54.5304 76 54 76Z",
    fill: "#E6EAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78 76H76C75.4696 76 74.9609 75.7893 74.5858 75.4142C74.2107 75.0391 74 74.5304 74 74C74 73.4696 74.2107 72.9609 74.5858 72.5858C74.9609 72.2107 75.4696 72 76 72H78C78.5304 72 79.0391 72.2107 79.4142 72.5858C79.7893 72.9609 80 73.4696 80 74C80 74.5304 79.7893 75.0391 79.4142 75.4142C79.0391 75.7893 78.5304 76 78 76ZM70 76H68C67.4696 76 66.9609 75.7893 66.5858 75.4142C66.2107 75.0391 66 74.5304 66 74C66 73.4696 66.2107 72.9609 66.5858 72.5858C66.9609 72.2107 67.4696 72 68 72H70C70.5304 72 71.0391 72.2107 71.4142 72.5858C71.7893 72.9609 72 73.4696 72 74C72 74.5304 71.7893 75.0391 71.4142 75.4142C71.0391 75.7893 70.5304 76 70 76Z",
    fill: "#FAA53D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_927_765",
    x1: 18.9841,
    y1: 103.175,
    x2: 20.1522,
    y2: 103.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_927_765",
    x1: 55.8636,
    y1: 46,
    x2: 98.4733,
    y2: 61.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.64083d1bb7c7c7b53bfd66f01c5619d5.svg";
export { ForwardRef as ReactComponent };